// extracted by mini-css-extract-plugin
export var bottomRightDock = "_13-0";